export default {

  maxVisibleRows: 1000, // Overall visible rows limit
  table: {
    partitionSize: 20, // Visible partition size
    visibleRange: 69, // Range of visible rows for calculation of partitions visibility
    invisibleRows: 23 // Rows top to the scroll line - invisible
  },

  searchDelay: 400

}



// WEBPACK FOOTER //
// ./src/config/view.js